'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equals = exports.regex = exports.number = exports.length = exports.exists = undefined;

var _utils = require('./utils');

var exists = exports.exists = (0, _utils.validatorFromFunction)(function (value) {
  return !!value;
});

var length = exports.length = (0, _utils.validatorFromFunction)(function (string) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      min = _ref.min,
      max = _ref.max;

  if (min === undefined && max === undefined) {
    throw new Error('length requires at least one parameter!');
  }

  var hasMinLength = min !== undefined ? string.length >= min : true;
  var hasMaxLength = max !== undefined ? string.length <= max : true;
  return hasMinLength && hasMaxLength;
}, true);

var number = exports.number = (0, _utils.validatorFromFunction)(function (value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      min = _ref2.min,
      max = _ref2.max;

  var isNumber = !isNaN(value);
  var hasMinValue = min !== undefined ? parseInt(value) >= min : true;
  var hasMaxValue = max !== undefined ? parseInt(value) <= max : true;
  return isNumber && hasMinValue && hasMaxValue;
}, true);

var regex = exports.regex = (0, _utils.validatorFromFunction)(function (value, pattern) {
  return value.match(pattern) !== null;
}, true);

var equals = exports.equals = (0, _utils.validatorFromFunction)(function (value, expectedValue) {
  return value === expectedValue;
}, false);

exports.default = {
  exists: exists,
  length: length,
  number: number,
  regex: regex,
  equals: equals
};